export function sortData(data, sort) {

  if(!sort?.column) return data;

  return [...data].sort((a,b)=>{

    const A = a[sort.column];
    const B = b[sort.column];

    if(A > B) return sort.direction === "asc" ? 1 : -1;
    if(A < B) return sort.direction === "asc" ? -1 : 1;

    return 0;

  });

}
